import { SuprimentosDetalhesDoPedidoComponent } from './pages/suprimentos/suprimentos-detalhes-do-pedido/suprimentos-detalhes-do-pedido.component';
import { SuprimentosHistoricoDePedidosComponent } from './pages/suprimentos/suprimentos-historico-de-pedidos/suprimentos-historico-de-pedidos.component';
import { NovoSuprimentoConclusionComponent } from './pages/suprimentos/novo-suprimento-conclusion/novo-suprimento-conclusion.component';
import { NovoSuprimentoAComponent } from './pages/suprimentos/novo-suprimento-a/novo-suprimento-a.component';
import { NovoSuprimentoComponent } from './pages/suprimentos/novo-suprimento/novo-suprimento.component';
import { ListagemDeOsVisaoDetalhadaComponent } from './pages/listagem-de-os/listagem-de-os-visao-detalhada/listagem-de-os-visao-detalhada.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { GestaoDeAcessoComponent } from './pages/gestao-de-acesso/listar-usuario-acesso/gestao-de-acesso.component';
import { DocumentosComponent } from './pages/documentos/documentos.component';
import { ListarPerfilAcessoComponent } from './pages/gestao-de-acesso/listar-perfil-acesso/listar-perfil-acesso.component';
import { LoginComponent } from './pages/login/login.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { AlterarSenhaComponent } from './pages/alterar-senha/alterar-senha.component';
import { AbrirChamadoComponent } from './pages/servicos/abrir-chamado/abrir-chamado/abrir-chamado.component';
import { ListarEquipamentosComponent } from './pages/servicos/listar-equipamentos/listar-equipamentos.component';
import { ListarHistoricoChamadosComponent } from './pages/servicos/listar-historico-chamados/listar-historico-chamados.component';
import { ListarEquipamentosDetalhesComponent } from './pages/servicos/listar-equipamentos-detalhes/listar-equipamentos-detalhes.component';
import { AbrirChamadoAComponent } from './pages/servicos/abrir-chamado/abrir-chamado-a/abrir-chamado-a.component';
import { AbrirChamadoBComponent } from './pages/servicos/abrir-chamado/abrir-chamado-b/abrir-chamado-b.component';
import { AbrirChamadoCComponent } from './pages/servicos/abrir-chamado/abrir-chamado-c/abrir-chamado-c.component';
import { AbrirChamadoDComponent } from './pages/servicos/abrir-chamado/abrir-chamado-d/abrir-chamado-d.component';
import { NovoSuprimentoCComponent } from './pages/suprimentos/novo-suprimento-c/novo-suprimento-c.component';
import { TecnicoComponent } from './pages/tecnico/tecnico.component';
import { RedirecionarChamadoComponent } from './pages/redirecionar-chamado/redirecionar-chamado.component';
import { ECompany } from './enums';
import { NovoSuprimentoKmDoBrasilAComponent } from './pages/suprimentos/novo-suprimento-km-do-brasil-a/novo-suprimento-km-do-brasil-a.component';
import { NovoSuprimentoBComponent } from './pages/suprimentos/novo-suprimento-b/novo-suprimento-b.component';
import { ParceiroComponent } from './pages/parceiro/parceiro.component';
import { ListarHistoricoChamadosFinalizadosComponent } from './pages/servicos/listar-historico-chamados-finalizados/listar-historico-chamados-finalizados.component';
import { AuthGuardService } from './services/guards/auth-guard.service';
import { LoginGuardService } from './services/guards/login-guard.service';
import { SemAutorizacaoGuardService } from './services/guards/sem-autorizacao-guard.service';
import { SemAutorizacoesComponent } from './pages/sem-autorizacoes/sem-autorizacoes.component';
import { NaoEncontradoGuardService } from './services/guards/nao-encontrado-guard.service';
import { LoginContainerComponent } from './pages/login-container/login-container.component';
import { RedefinirSenhaComponent } from './pages/redefinir-senha/redefinir-senha.component';
import { ConcluirRedefinirSenhaComponent } from './pages/concluir-redefinir-senha/concluir-redefinir-senha.component';
import { AlterarSenhaGuard } from './services/guards/alterar-senha.guard';
import { ListarContratosComponent } from './pages/listagem-de-contratos/listar-contratos/listar-contratos.component';
import { ListarContratoDetalhesComponent } from './pages/listagem-de-contratos/listar-contrato-detalhes/listar-contrato-detalhes.component';
import { SuprimentosHistoricoDePedidosEntregueComponent } from './pages/suprimentos/suprimentos-historico-de-pedidos-entregue/suprimentos-historico-de-pedidos-entregue.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginContainerComponent,
    canActivate: [LoginGuardService],
    children: [
      {
        path: '',
        component: LoginComponent,
        canActivate: [LoginGuardService]
      },
      {
        path: 'redefinir-senha',
        component: RedefinirSenhaComponent,
        canActivate: [LoginGuardService]
      },
      {
        path: 'redefinir-senha/concluir',
        component: ConcluirRedefinirSenhaComponent,
        canActivate: [LoginGuardService]
      }
    ],
    data: {
      autorizacaoNecessaria: 'rotaLogin'
    }
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'visualizarDashboard'
    }
  },
  {
    path: 'gestao-de-acesso',
    component: GestaoDeAcessoComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'listarUsuarios'
    }
  },
  {
    path: 'documentos',
    component: DocumentosComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'visualizarDashboard'
    }
  },
  // {
  //   path: 'demonstrativo-financeiro',
  //   component: ListarDemonstrativoFinanceiroComponent,
  //   canActivate: [AuthGuardService],
  //   data: {
  //     autorizacaoNecessaria: 'listarDemonstrativosFinanceiros'
  //   }
  // },
  // {
  //   path: 'demonstrativo-financeiro/:codContrato/:mesAno/:codFatura',
  //   component: ListarFechamentoComponent,
  //   canActivate: [AuthGuardService],
  //   data: {
  //     autorizacaoNecessaria: 'exibirDetalhesDemonstrativoFinanceiro'
  //   }
  // },
  // {
  //   path: 'boletos',
  //   component: ListarBoletosComponent,
  //   canActivate: [AuthGuardService],
  //   data: {
  //     autorizacaoNecessaria: 'listarBoletos'
  //   }
  // },
  {
    path: 'gestao-de-acesso/perfil',
    component: ListarPerfilAcessoComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'listarPerfis'
    }
  },
  // {
  //   path: 'listagem-inventario',
  //   component: ListagemInventarioComponent,
  //   canActivate: [AuthGuardService],
  //   data: {
  //     autorizacaoNecessaria: 'listarInventarios'
  //   }
  // },
  // {
  //   path: 'listagem-inventario/detalhes/:Numserie',
  //   component: ListagemInventarioDetalhesComponent,
  //   canActivate: [AuthGuardService],
  //   data: {
  //     autorizacaoNecessaria: 'exibirDetalhesInventario'
  //   }
  // },
  {
    path: 'equipamentos',
    component: ListarEquipamentosComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'listarEquipamentos'
    }
  },
  {
    path: 'equipamentos/detalhes/:numSerie/:codContrato',
    component: ListarEquipamentosDetalhesComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'visualizarChamadosEquipamento'
    }
  },
  {
    path: 'historico-chamados',
    component: ListarHistoricoChamadosComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'listarChamadosAndamento'
    }
  },
  {
    path: 'equipamentos/abrir-chamado',
    redirectTo: 'equipamentos',
    pathMatch: 'full'
  },
  {
    path: 'novo-suprimento/abrir-chamado',
    component: NovoSuprimentoComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'abrirChamadoSuprimentos'
    },
    children: [
      {
        path: `${ECompany.APNETWORKS}/1`,
        component: NovoSuprimentoAComponent
      },
      {
        path: '2',
        component: NovoSuprimentoBComponent
      },
      {
        path: '3',
        component: NovoSuprimentoCComponent
      },
      {
        path: `${ECompany.KM_DO_BRASIL}/1`,
        component: NovoSuprimentoKmDoBrasilAComponent
      },
      {
        path: '4/:codigo',
        component: NovoSuprimentoConclusionComponent
      }
    ]
  },
  {
    path: 'suprimentos/historico-de-pedidos',
    component: SuprimentosHistoricoDePedidosComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'listarHistoricosPedidos'
    }
  },
  {
    path: 'suprimentos/historico-de-pedidos-entregue',
    component: SuprimentosHistoricoDePedidosEntregueComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'listarHistoricosPedidos'
    }
  },
  {
    path: 'suprimentos/historico-de-pedidos/:codOrcamento',
    component: SuprimentosDetalhesDoPedidoComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'exibirDetalhesPedido'
    }
  },
  {
    path: 'equipamento/abrir-chamado',
    component: AbrirChamadoComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'abrirChamadoEquipamento'
    },
    children: [
      {
        path: '1',
        component: AbrirChamadoAComponent
      },
      {
        path: '2',
        component: AbrirChamadoBComponent
      },
      {
        path: '3',
        component: AbrirChamadoCComponent
      },
      {
        path: '4',
        component: AbrirChamadoDComponent
      }
    ]
  },
  {
    path: 'historico-de-chamados/:numSerie/:codContrato',
    component: ListagemDeOsVisaoDetalhadaComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'exibirDetalhesChamado'
    }
  },
  {
    path: 'listagem-de-contratos',
    component: ListarContratosComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'listarContratos'
    }
  },
  {
    path: 'listagem-de-contratos/detalhes/:codContrato',
    component: ListarContratoDetalhesComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'exibirDetalhesContrato'
    }
  },
  {
    path: 'encaminhar-tecnico',
    component: TecnicoComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'redirecionar-chamado',
    component: RedirecionarChamadoComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'encaminhar-parceiro',
    component: ParceiroComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'historico-chamados/finalizados',
    component: ListarHistoricoChamadosFinalizadosComponent,
    canActivate: [AuthGuardService],
    data: {
      autorizacaoNecessaria: 'listarChamadosFinalizados'
    }
  },
  {
    path: 'sem-autorizacoes',
    component: SemAutorizacoesComponent,
    canActivate: [SemAutorizacaoGuardService]
  },
  {
    path: 'alterar-senha',
    component: AlterarSenhaComponent,
    canActivate: [AlterarSenhaGuard]
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [NaoEncontradoGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
